<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

    <b-form @submit.prevent="save">
      <b-card>
        <b-form-row>
          <lg-form-input invalidFeedback="Informe uma descrição válida!" description="" :error="$v.form.descricao"
            v-model="form.descricao" label="Descrição:*" cols="12" />
          <lg-form-input invalidFeedback="Informe uma validade válida!" description="" :error="$v.form.validade"
            v-model="form.validade" label="Validade (dias):*" cols="12" type="number" />
        </b-form-row>

        <b-form-group label="Status:*" class="ml-3">
          <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
            name="status-inline"></b-form-radio-group>
        </b-form-group>


        <b-form-row>

          <b-col cols="3"></b-col>
          <b-col cols="6" class="text-center">
            <b-button id="salvarTipoDocumento" class=" my-2" size="sm" pill variant="success" @click="save">
              <b-icon icon="check-circle" />
              <b-tooltip target="salvarTipoDocumento" title="Salvar"></b-tooltip>

            </b-button>

            <b-button id="cancelarTipoDocumento" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
              <b-icon icon="x-circle" />
              <b-tooltip target="cancelarTipoDocumento" title="Cancelar"></b-tooltip>

            </b-button>
          </b-col>
          <b-col cols="3"></b-col>

        </b-form-row>

      </b-card>
    </b-form>
  </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";

import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
  components: {
    LgFormInput,
  },
  mixins: [FormResourceMixin],
  props: {
    id: Number,
    departamentoId: Number,
    prefix: {
      type: String,
      default: "",
    },
  },
  validations: {
    form: {
      descricao: { required },
      validade: { required },
      situacao: { required },
    },
  },
  data() {
    return {
      statusOptions: [
        { text: "Ativo", value: 1 },
        { text: "Inativo", value: 0 },
      ],

      showModal: true,
      title: 'Cadastro',
      form: {
        descricao: "",
        validade: "",
        situacao: 1,
      },
    };
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/tipo-documento`);
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
    } else {
      this.form.situacao = 1;
    }
  },
  methods: {
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch();
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        });
        return;
      }

      try {
        await this.$saveResource(this.form);
      }
      catch (error) {
        this.$notify({
          type: "danger",
          message: error,
        });

      }
      this.cancelar();


    },
    cancelar() {
      this.$emit("close");
    },

  },
};
</script>
